// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"shared-components-RelatedWorks-RelatedWorks__gridContainer--1z4kH"};